/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleUp: {
  name: 'triangle-up';
  data: string;
} = {
  name: 'triangle-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 10H4l4-4 4 4Z" fill="currentColor"/></svg>`,
};
